import Error404 from "pages/Error404";
import { Navigate, useParams } from "react-router";

export default function RedirectHandler() {
  const { type, userId } = useParams();
  const valid = [type, userId].every(Boolean);
  if (!valid) return <Error404 />;
  return <Navigate to={`/${userId}`} replace />;
}
